import React from 'react';
import Train1 from './../../assets/images/ico_train1.png';
import Train2 from '../../assets/images/ico_train2.png';
import Train3 from '../../assets/images/ico_train3.png';
import Train4 from '../../assets/images/ico_train4.png';
import Train5 from '../../assets/images/ico_train5.png';
import { TrainsType } from '../../apis/Transits.api';

interface props {
  trainData: TrainsType[];
  setDetailDisp: React.Dispatch<React.SetStateAction<TrainsType[] | undefined>>;
}

const GetTrainImage = (course: number) => {
  switch (course) {
    case 1:
      return Train1;
    case 2:
      return Train2;
    case 3:
      return Train3;
    case 4:
      return Train4;
    case 5:
      return Train5;
  }
};

const StringDisplayShiftPositionX = (length: number) => {
  return (length - 1) * 8 + 7;
};

export const Train: React.FC<props> = (props) => {
  const data = props.trainData;
  const setDetailDisp = props.setDetailDisp;

  return (
    <>
      <g
        onClick={() => {
          setDetailDisp(data);
        }}
        cursor='pointer'
      >
        <image
          key={`${'train_' + data[0].id}`}
          x={data[0].x - 20}
          y={data[0].y - 87}
          xlinkHref={GetTrainImage(data[0].course)}
        ></image>
        {data[0].course === 2 && (
          <text
            fontSize='16'
            x={
              data[0].x -
              StringDisplayShiftPositionX(
                data[0].display_name === undefined
                  ? 0
                  : data[0].display_name.length
              )
            }
            y={data[0].y - 88}
            fill='yellow'
          >
            {data[0].display_name}
          </text>
        )}

        <text
          fontSize={data[0].train_no.toString().length == 3 ? '16' : '14'}
          x={
            data[0].train_no.toString().length == 3
              ? data[0].x - 13
              : data[0].x - 15.5
          }
          y={data[0].y - 67}
          fill='white'
          onClick={() => {
            setDetailDisp(data);
          }}
        >
          {data[0].train_no}
        </text>
      </g>
    </>
  );
};
